import React from 'react';
import { Modal, Timeline, Typography } from 'antd';
import { formatDate } from '../../utils/dateUtils';

const { Text } = Typography;

const OwnershipHistoryModal = ({ visible, onClose, candidate }) => {
  const buildOwnershipHistory = () => {
    const allOwnerships = [];

    candidate.referrals?.forEach(referral => {
      if (referral.ownerships) {
        referral.ownerships.forEach(ownership => {
          allOwnerships.push({
            ...ownership,
            referrer: referral.user,
            owner: referral.user ? `${referral.user.firstName} ${referral.user.lastName}` : 'Unknown',
            startDate: formatDate(ownership.startDate) || 'N/A',
            endDate: formatDate(ownership.endDate) || 'Present',
            reason: ownership.reason || 'N/A'
          });
        });
      }
    });

    const sorted = allOwnerships.sort((a, b) => {
      const dateA = new Date(a.startDate === 'N/A' ? 0 : a.startDate);
      const dateB = new Date(b.startDate === 'N/A' ? 0 : b.startDate);
      return dateA - dateB;
    });

    if (sorted.length > 0) {
      sorted[0].reason = sorted[0].reason === 'N/A' ? 'Active Referrer Initialized' : sorted[0].reason;
    }

    return sorted;
  };

  const sortedOwnershipLog = buildOwnershipHistory();

  return (
    <Modal
      title="Referral History"
      open={visible}
      onCancel={onClose}
      footer={null}
      width={600}
    >
      <Timeline mode="left" style={{ paddingLeft: '0', marginTop: '16px' }}>
        {sortedOwnershipLog.map((log, index) => (
          <React.Fragment key={index}>
            <Timeline.Item style={{ paddingBottom: '8px' }}>
              <div>
                <Text strong style={{ fontSize: '15px', display: 'block', marginBottom: '4px' }}>
                  {log.owner}
                </Text>
                <Text type="secondary" style={{ fontSize: '13px', display: 'block' }}>
                  {log.startDate} - {log.endDate}
                </Text>
              </div>
            </Timeline.Item>
            {index < sortedOwnershipLog.length - 1 && sortedOwnershipLog[index + 1] && (
              <Timeline.Item 
                dot={<div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#d9d9d9' }} />} 
                style={{ paddingBottom: '8px' }}
              >
                <div style={{ 
                  backgroundColor: '#f5f5f5', 
                  padding: '8px 12px', 
                  borderRadius: '4px',
                  marginLeft: '-12px',
                  marginRight: '-12px'
                }}>
                  <Text type="secondary" style={{ fontSize: '12px', fontStyle: 'italic', color: '#666' }}>
                    {sortedOwnershipLog[index + 1].reason}
                  </Text>
                </div>
              </Timeline.Item>
            )}
          </React.Fragment>
        ))}
        {sortedOwnershipLog.length > 0 && sortedOwnershipLog[0] && (
          <Timeline.Item 
            dot={<div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#d9d9d9' }} />} 
            style={{ paddingBottom: '0' }}
          >
            <div style={{ 
              backgroundColor: '#f5f5f5', 
              padding: '8px 12px', 
              borderRadius: '4px',
              marginLeft: '-12px',
              marginRight: '-12px'
            }}>
              <Text type="secondary" style={{ fontSize: '12px', fontStyle: 'italic', color: '#666' }}>
                {sortedOwnershipLog[0].reason}
              </Text>
            </div>
          </Timeline.Item>
        )}
      </Timeline>
    </Modal>
  );
};

export default OwnershipHistoryModal;